// 비로그인 전용 라우트 — 로그인 상태면 원래 가려던 URL 또는 /dashboard로 리다이렉트
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'

export default function PublicRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return (
      <div className="min-h-screen bg-canvly-warm flex items-center justify-center">
        <div className="w-5 h-5 border-2 border-canvly-gold border-t-transparent rounded-full animate-spin" />
      </div>
    )
  }

  if (user) {
    const from = (location.state as any)?.from?.pathname as string | undefined
    return <Navigate to={from || '/dashboard'} replace />
  }

  return <>{children}</>
}
